export default {
  setCommunities(state, communities) {
    state.communities = communities;
  },
  setCommunity(state, community) {
    state.community = community;
  },
  setUnreadCount(state, unreadCount) {
    state.unreadCount = unreadCount;
  },
  setTrending(state, { id, posts }) {
    state.trendingCommunityId = id;
    state.trendingPosts = posts;
  }
};
